import { Rule } from '@webkit/validation/value';

export const rangeLength = (low: number, high: number, error?: string) =>
    ({
        id: 'range-length',
        validator: value => {
            if (value === undefined || value === null) return true;
            return value.length >= low && value.length <= high;
        },
        error: value => {
            if (error) return error;

            if (typeof value === 'string') {
                return `Must be ${low} to ${high} characters (${value.length})`;
            }

            if (Array.isArray(value)) {
                return `Select ${low} to ${high} items (${value.length})`;
            }

            return `Must be ${low} to ${high}`;
        },
    } as Rule<string | any[]>);
